// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  workflow: require('./workflow.json'),

  // apiEndpoint: 'http://localhost:58830/api',
  // tokenEndpoint: 'http://localhost:58830/token',
  // logoutUrl: 'https://www.cert.eauth.usda.gov/Logout/logoff.asp',
  // loginUrl: 'http://localhost:51274/LoginPage.aspx',
  // serverUrl: 'http://localhost:51274'

  // apiEndpoint: 'https://devapps.fas.usda.gov/newgainapi/api',
  // tokenEndpoint:'https://devapps.fas.usda.gov/newgainapi/token',
  // logoutUrl:'https://devapps.fas.usda.gov/newgain',
  // loginUrl:'https://devapps.fas.usda.gov/newgain/LoginPage.aspx',
  // serverUrl:'https://devapps.fas.usda.gov/newgain/'

  apiEndpoint: 'https://stgapps.fas.usda.gov/newgainapi/api',
  tokenEndpoint:'https://stgapps.fas.usda.gov/newgainapi/token',
  logoutUrl:'https://stgapps.fas.usda.gov/newgain',
  //loginUrl:'https://stgapps.fas.usda.gov/newgain/LoginPage.aspx',

  // NewEauth LoginPage redirection
  loginUrl:'https://www.cert.eauth.usda.gov/eauth/b/usda/login?TARGET=-SM-https://stgapps.fas.usda.gov/NewGAIN/LoginPage.aspx ',
  serverUrl:'https://stgapps.fas.usda.gov/newgain/'

  // apiEndpoint: 'https://apps.fas.usda.gov/newgainapi/api',
  // tokenEndpoint:'https://apps.fas.usda.gov/newgainapi/token',
  // logoutUrl:'https://apps.fas.usda.gov/newgain',
  // loginUrl:'https://apps.fas.usda.gov/newgain/LoginPage.aspx',
  // serverUrl:'https://apps.fas.usda.gov/newgain/'

  // apiEndpoint: 'https://apps.fas.usda.gov/newgainapi/api',
  // tokenEndpoint:'https://apps.fas.usda.gov/newgainapi/token',
  // // apiEndpoint: 'https://gain.fas.usda.gov/newgainapi/api',
  // // tokenEndpoint:'https://gain.fas.usda.gov/newgainapi/token',
  // logoutUrl:'https://gain.fas.usda.gov/',
  // loginUrl:'https://gain.fas.usda.gov/LoginPage.aspx',
  // serverUrl:'https://gain.fas.usda.gov/'


};



// WEBPACK FOOTER //
// ./src/environments/environment.ts